import React from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { deleteReferral } from './actions/delete-referral';

import { UiButton } from '../ui/ui-button';

import { confirm } from '../widgets/confirmation-dialog';

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    deleteReferral: (referralId: number) => dispatch(deleteReferral(referralId)),
  },
});

type InputProps = {
  referral: Referral;
};

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & DispatchProps;

export const RemoveReferralButton = connect(
  null,
  mapDispatchToProps,
)(({ referral, actions }: Props) => {
  const handleShowDialog = async () => {
    const {
      Contact: { Person },
    } = referral;
    const confirmResponse = await confirm(
      `Are you sure you want to remove ${Person.firstName} ${Person.lastName}'s referral?`,
    );
    if (!confirmResponse) {
      return;
    }
    actions.deleteReferral(referral.referralId);
  };

  return (
    <UiButton onClick={handleShowDialog} variant="tertiary" size="xs">
      Remove
    </UiButton>
  );
});
